import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';

/**
 * Resolved related records for an agent category activity event, keyed by relation.
 */
export class AgentCategoryActivityEventHydration {
  link?: ActivityLinkHydration;
}
